var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "Signature_Control"
  }, [_c("div", {
    staticClass: "card_box",
    class: {
      highlighted: _vm.itemA.isHighlighted,
      selected: _vm.itemA.isSelectedShow
    },
    on: {
      mouseover: function ($event) {
        return _vm.highlight(_vm.indexA);
      },
      mouseleave: function ($event) {
        return _vm.removeHighlight(_vm.indexA);
      },
      click: function ($event) {
        return _vm.toggleSelection(_vm.indexA);
      }
    }
  }, [_c("div", {
    staticClass: "nameBox"
  }, [_c("div", {
    staticClass: "paragraphstyle",
    style: {
      width: _vm.item.widthSet
    },
    domProps: {
      innerHTML: _vm._s(_vm.item.content)
    }
  })]), _vm.itemA.isSelected ? [_c("control-action", {
    attrs: {
      "current-control-item": _vm.itemA,
      formDataArray: _vm.formDataArrayA,
      "current-control-index": _vm.indexA
    },
    on: {
      relationClick: _vm.relationClick,
      formeClick: _vm.formeClick
    }
  })] : _vm._e()], 2), _vm.itemA.editing ? [_c("a-form-model", {
    ref: "formData",
    attrs: {
      model: _vm.itemA,
      rules: _vm.rulesTrue
    }
  }, [_c("div", {
    staticClass: "box_nav"
  }, [_c("div", {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("标识")
    }
  }, [_c("a-input", {
    staticClass: "input_winth_100",
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.itemA.mark,
      callback: function ($$v) {
        _vm.$set(_vm.itemA, "mark", $$v);
      },
      expression: "itemA.mark"
    }
  })], 1), _c("div", {
    staticStyle: {
      display: "flex"
    }
  }, [_c("div", {
    staticStyle: {
      width: "71px",
      "font-weight": "bold"
    }
  }, [_vm._v("正文")]), _c("div", [_c("quill-editor", {
    ref: "myTextEditor2",
    staticStyle: {
      height: "400px",
      "margin-bottom": "30px"
    },
    attrs: {
      options: _vm.quillOption
    },
    model: {
      value: _vm.itemA.content,
      callback: function ($$v) {
        _vm.$set(_vm.itemA, "content", $$v);
      },
      expression: "itemA.content"
    }
  })], 1)])], 1), _c("div", {
    staticClass: "nav_item_q"
  }, [_c("div", {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c("span", {
    staticClass: "itamNav"
  }, [_vm._v("*")])]), _c("div", {
    staticClass: "nav_qain"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("宽度限制")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "280px"
    },
    attrs: {
      placeholder: _vm.$t("请选择宽度")
    },
    model: {
      value: _vm.itemA.widthSet,
      callback: function ($$v) {
        _vm.$set(_vm.itemA, "widthSet", $$v);
      },
      expression: "itemA.widthSet"
    }
  }, [_c("a-select-option", {
    attrs: {
      label: _vm.$t("10%"),
      value: "$t('10%')"
    }
  }, [_vm._v(_vm._s(_vm.$t("10%")))]), _c("a-select-option", {
    attrs: {
      label: _vm.$t("20%"),
      value: "$t('20%')"
    }
  }, [_vm._v(_vm._s(_vm.$t("20%")))]), _c("a-select-option", {
    attrs: {
      label: _vm.$t("30%"),
      value: "$t('30%')"
    }
  }, [_vm._v(_vm._s(_vm.$t("30%")))]), _c("a-select-option", {
    attrs: {
      label: _vm.$t("40%"),
      value: "$t('40%')"
    }
  }, [_vm._v(_vm._s(_vm.$t("40%")))]), _c("a-select-option", {
    attrs: {
      label: _vm.$t("50%"),
      value: "$t('50%')"
    }
  }, [_vm._v(_vm._s(_vm.$t("50%")))]), _c("a-select-option", {
    attrs: {
      label: _vm.$t("60%"),
      value: "$t('60%')"
    }
  }, [_vm._v(_vm._s(_vm.$t("60%")))]), _c("a-select-option", {
    attrs: {
      label: _vm.$t("70%"),
      value: "$t('70%')"
    }
  }, [_vm._v(_vm._s(_vm.$t("70%")))]), _c("a-select-option", {
    attrs: {
      label: _vm.$t("80%"),
      value: "$t('80%')"
    }
  }, [_vm._v(_vm._s(_vm.$t("80%")))]), _c("a-select-option", {
    attrs: {
      label: _vm.$t("90%"),
      value: "$t('90%')"
    }
  }, [_vm._v(_vm._s(_vm.$t("90%")))]), _c("a-select-option", {
    attrs: {
      label: _vm.$t("100%"),
      value: "$t('100%')"
    }
  }, [_vm._v(_vm._s(_vm.$t("100%")))])], 1)], 1)], 1)]), _c("div", {
    staticClass: "btn_close"
  }, [_c("a-button", {
    staticClass: "title_but",
    on: {
      click: function ($event) {
        return _vm.formeClase(_vm.index);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("关闭")))])], 1)])])] : _vm._e()], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };